export default "__VITE_ASSET__CaIXfIPZ__"